/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSddcSourceAccount } from './irrSddcSourceAccount';
import { IrrSddcTargetAccount } from './irrSddcTargetAccount';


export interface IrrSddcTrustRelationship { 
    shadowAccount?: IrrSddcSourceAccount;
    sddcAccount?: IrrSddcTargetAccount;
}

